export default __webpack_public_path__ + "static/media/img_4.67a54e49.svg";